import { Grid, Typography } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import { theme } from "../styles/theme";
import MapBandsLegendCircle from "./MapBandsLegendCircle";
import ChevronLeftIcon from "./icons/ChevronLeftIcon";
import ChevronRightIcon from "./icons/ChevronRightIcon";
import EqualsIcon from "./icons/EqualsIcon";

export default function MapBandsLegendItem({ color, type, count }) {
  return (
    <Grid container spacing={0.5} alignItems="center">
      <Grid item xs="auto">
        <MapBandsLegendCircle color={color} />
      </Grid>
      <Grid item xs="auto">
        <SvgIcon
          sx={{
            color: theme.palette.common.black,
            transform: "translateY(0.25rem)",
          }}
        >
          {type === ">" && <ChevronRightIcon />}
          {type === "<" && <ChevronLeftIcon />}
          {type === "=" && <EqualsIcon />}
        </SvgIcon>
      </Grid>
      <Grid item xs="auto">
        <Typography
          variant="body1"
          sx={{ fontSize: "0.875rem", width: "1.5rem" }}
        >
          {count}
        </Typography>
      </Grid>
      <Grid item xs>
        <Typography variant="body1" sx={{ fontSize: "0.875rem" }}>
          Bands/Musiker*innen
        </Typography>
      </Grid>
    </Grid>
  );
}
